var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative my-4 lg:my-8" }, [
    _c(
      "div",
      {
        ref: "rootEl",
        staticClass:
          "bosnia-delegation-carousel swiper-container custom-overflow",
        attrs: { "manual-init": "" },
      },
      [_c("div", { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "swiper-button-prev swiper-nav-btn mt-0 js-swiper-prev w-12 h-12 left-arrow",
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 0L9.41 1.41L3.83 7H16V9H3.83L9.41 14.59L8 16L0 8L8 0Z",
                fill: "white",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "swiper-button-next swiper-nav-btn mt-0 js-swiper-next h-12 w-12 right-arrow",
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z",
                fill: "white",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }